const ConfigDB = {
  settings: {
    layout_type: 'ltr',
    layout_class: 'compact-wrapper',
    sidebar: {
      iconType: 'stroke',
    },
    sidebar_setting: 'default-sidebar',
  },
  color: {
    primary_color: '#006666',
    secondary_color: '#FE6A49',
    mix_background_layout: 'light-only',
  }
}
export default ConfigDB;